import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useParams } from 'react-router-dom'
import SignPanel from '../../components/SignPanel'
import {
  recipientComplete, recipientDownload, recipientInfo, recipientPdfUrl, recipientPrepare,
  recipientText, type RecipientSessionInfo,
} from '../../lib/portal'

export default function RecipientSignPage() {
  const { token = '' } = useParams()
  const [info, setInfo]   = useState<RecipientSessionInfo | null>(null)
  const [text, setText]   = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [done, setDone]   = useState(false)

  useEffect(() => {
    recipientInfo(token).then(setInfo).catch(() => setError('Bağlantı geçersiz veya süresi dolmuş.'))
  }, [token])

  useEffect(() => {
    if (info?.viewMode === 'text') {
      recipientText(token).then(setText).catch(() => setText('(Belge görüntülenemedi.)'))
    }
  }, [info, token])

  if (error) return <Centered><div className="card border-red-200 bg-red-50"><p className="text-sm text-red-700">{error}</p></div></Centered>
  if (!info) return <Centered><p className="text-sm text-[var(--color-fg-muted)]">Yükleniyor…</p></Centered>

  return (
    <>
      <Helmet><title>İmzala: {info.documentTitle} — W.Sign</title><meta name="robots" content="noindex, nofollow" /></Helmet>
      <section className="container-page py-10">
        <h1 className="text-2xl font-semibold">İmza talebi: {info.documentTitle}</h1>
        <p className="mt-1 text-sm text-[var(--color-fg-muted)]">
          Belgeyi inceleyin ve nitelikli e-imzanızla imzalayın.
        </p>

        <div className="mt-6 grid gap-6 lg:grid-cols-[1.4fr_1fr]">
          <div className="card p-0 overflow-hidden">
            {info.viewMode === 'pdf' ? (
              <iframe title="Belge" src={recipientPdfUrl(token)} className="h-[70vh] w-full" />
            ) : info.viewMode === 'text' ? (
              <pre className="h-[70vh] w-full overflow-auto whitespace-pre-wrap break-words p-4 text-sm font-mono">
                {text ?? 'Yükleniyor…'}
              </pre>
            ) : (
              <div className="flex h-[70vh] flex-col items-center justify-center gap-4 p-6 text-center">
                <p className="text-sm text-[var(--color-fg-muted)]">
                  Bu belge türü tarayıcıda görüntülenemiyor.
                </p>
                <button
                  type="button" className="btn-primary"
                  onClick={() => recipientDownload(token, info.documentTitle)}
                >
                  Belgeyi indir
                </button>
              </div>
            )}
          </div>

          <div>
            {done ? (
              <div className="card border-emerald-200 bg-emerald-50">
                <h2 className="text-lg font-semibold text-emerald-900">İmzanız alındı</h2>
                <p className="mt-2 text-sm text-emerald-800">
                  Belge başarıyla imzalandı. Bu sekmeyi kapatabilirsiniz; gönderen bilgilendirildi.
                </p>
              </div>
            ) : info.signable ? (
              <SignPanel
                isPdf={info.viewMode === 'pdf'}
                prepare={(cert, timestamp, longTerm) => recipientPrepare(token, cert, timestamp, longTerm)}
                complete={(sid, raw) => recipientComplete(token, sid, raw)}
                onSuccess={() => setDone(true)}
              />
            ) : (
              <div className="card">
                <p className="text-sm text-[var(--color-fg-muted)]">
                  Bu belge şu anda imzalanamıyor (durum: {info.status}).
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  )
}

function Centered({ children }: { children: React.ReactNode }) {
  return <section className="container-page py-16 max-w-md">{children}</section>
}
